// Free gift timer functionality
// Loads only on cart/checkout pages to improve INP

(function() {
  'use strict';
  
  const wproduct = {variant: 31356926853154, meta: {selling_plan_id: '689283760429'}};
  const TIMER_KEY = "freeGiftExpiryTime";

  // ✅ UTM DETECTION
  const params = new URLSearchParams(window.location.search);

  if (params.get('utm_source')) {
    localStorage.setItem('utm_source', params.get('utm_source'));
  }
  if (params.get('utm_medium')) {
    localStorage.setItem('utm_medium', params.get('utm_medium'));
  }

  const UTM_SOURCE = localStorage.getItem('utm_source');
  const UTM_MEDIUM = localStorage.getItem('utm_medium');

  const isTikTok = UTM_SOURCE === 'tiktok';
  const isQR = UTM_SOURCE === 'TY_CARD' && UTM_MEDIUM === 'qr_code';

  // ✅ DIFFERENT PRODUCT BASED ON URL
  let FREE_VARIANT_ID = 51543130439981; // default

  if (isTikTok) {
    FREE_VARIANT_ID = 52004410982701; // replace with TikTok variant
  }

  if (isQR) {
    FREE_VARIANT_ID = 51543130439981; // replace with QR variant
  }

  // ✅ prevent mismatch between sessions
  const storedVariant = localStorage.getItem('free_gift_variant');

  if (storedVariant && storedVariant !== String(FREE_VARIANT_ID)) {
    localStorage.removeItem(TIMER_KEY);
  }

  localStorage.setItem('free_gift_variant', FREE_VARIANT_ID);
  
  // Klaviyo form submission handler
  window.addEventListener("klaviyoForms", async function (e) {
    if (!e.detail || e.detail.type !== "submit") return;
    const meta = e.detail.metaData;
    if (!meta) return;
    const phone = meta.$phone_number;
    if (!phone) return;
    
    try {
      const cart = await fetch("/cart.js").then((r) => r.json());
      const alreadyInCart = cart.items.some(
        (i) => i.variant_id === FREE_VARIANT_ID
      );
      if (alreadyInCart) {
        return;
      }
      
      const itemsToAdd = [{ id: FREE_VARIANT_ID, quantity: 1 }];
      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items: itemsToAdd }),
      });
      
      const updatedCart = await fetch("/cart.js").then((r) => r.json());
      document.dispatchEvent(
        new CustomEvent("cart:items-added", { detail: { cart: updatedCart } })
      );
      document.dispatchEvent(new Event("cart:refresh"));

      const cartTrigger = document.querySelector(".cart__icon_button");
      if (cartTrigger) {
        cartTrigger.click();
      }
      const closeButton = document.querySelector(".klaviyo-close-form");
      if (closeButton) closeButton.click();
      
      // ✅ Dynamic timer duration
      let duration = 20 * 60 * 1000; // default

      if (isTikTok) duration = 10 * 60 * 1000;
      if (isQR) duration = 30 * 60 * 1000;

      const expiry = Date.now() + duration;

      localStorage.setItem(TIMER_KEY, expiry);
      startTimer();
    } catch (err) {
      console.error("Error adding free product:", err);
    }
  });
  
  // Remove free gift when timer expires
  async function removeFreeGift() {
    try {
      const cart = await fetch("/cart.js").then((r) => r.json());
      const item = cart.items.find((i) => i.variant_id === FREE_VARIANT_ID);
      if (!item) return;

      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: item.key, quantity: 0 }),
      });
      document.dispatchEvent(new Event("cart:refresh"));
      localStorage.removeItem(TIMER_KEY);
      console.log("🗑 Free gift removed after timer expired");
    } catch (err) {
      console.error("Error removing free gift:", err);
    }
  }

  // Countdown timer display
  function startTimer() {
    const expiry = Number(localStorage.getItem(TIMER_KEY));
    if (!expiry) return;
    
    let drawerTimer = document.querySelector("#free-gift-timer");
    if (!drawerTimer) {
      const drawer =
        document.querySelector("#cart-drawer-live-region-checkout") ||
        document.querySelector(".cart-drawer");

      if (!drawer) {
        setTimeout(startTimer, 1000);
        return;
      }
      
      drawerTimer = document.createElement("div");
      drawerTimer.id = "free-gift-timer";
      drawerTimer.style.cssText =
        "text-align:center;margin:10px 0;font-weight:600;color:#d32f2f;";
      drawer.appendChild(drawerTimer);
    }
    
    const interval = setInterval(async () => {
      const timeLeft = expiry - Date.now();
      if (timeLeft <= 0) {
        clearInterval(interval);
        drawerTimer.textContent = "Free gift offer expired.";
        await removeFreeGift();
        return;
      }
      const minutes = Math.floor(timeLeft / 60000);
      const seconds = Math.floor((timeLeft % 60000) / 1000);

      // ✅ Dynamic label
      let label = "Free BeyBlade offer";

      if (isTikTok) label = "🔥 TikTok Exclusive Offer";
      if (isQR) label = "🎟 QR Special Offer";

      drawerTimer.innerHTML = `⏳ ${label}<br> expiring in ${minutes}:${seconds
        .toString()
        .padStart(2, "0")}!`;
    }, 1000);
  }
  
  // Start timer on page load if expiry exists
  if (document.readyState === 'loading') {
    document.addEventListener("DOMContentLoaded", startTimer);
  } else {
    startTimer();
  }
})();